
export enum UserType {
    HQAdmin = 1,
    RegionalAdmin = 2,
    DataCollector = 3,
    DataManager = 4,
    DataUser = 5,
    DataManagerSupply = 6,
    DataManagerRegional = 7,
    DataManagerSupplyRegional = 8
}

export enum UserTypeName {
    HQAdmin = 'HQ Admin',
    RegionalAdmin = 'Regional Admin',
    DataCollector = 'Data Collector',
    DataManager = 'Data Manager – Global',
    DataUser = 'Data User',
    DataManagerSupply = 'Data Manager Supply – Global',
    DataManagerRegional = 'Data Manager – Regional',
    DataManagerSupplyRegional = 'Data Manager Supply – Regional'
}


// WEBPACK FOOTER //
// ./src/constants/Enum/UserType.tsx